import Vue from 'vue';
import moment from 'moment';

if (!Vue.prototype.hasOwnProperty('$moment')) {
  Object.defineProperty(Vue.prototype, '$moment', {
    get: function get() {
      return moment;
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/moment.js
// module id = ./.nuxt/moment.js
// module chunks = 20